import { useCallback } from 'react';
import { loadBusinessCollectionAsync } from '../../data-layer/business/actions';
import { BusinessCollection } from '../../data-layer/business/constants';
import {
    selectBusinessCollection,
    selectBusinessCollectionFilters,
    selectBusinessCollectionLoading,
} from '../../data-layer/business/selectors';
import { useDispatch } from '../../data-layer/useDispatch';
import { useSelector } from '../../data-layer/useSelector';
import type { BusinessModel } from '../../data-layer/business/types';

export interface UseBusinessCollectionPayload {
    filters: Record<string, any>;
    isLoading: boolean;
    businesses: BusinessModel[];
    onLoadNext: (params?: Record<string, any>) => void;
}

interface UseBusinessCollectionProps {
    namespace: BusinessCollection;
}

// TODO: При необходимости можно будет поддержать бесконечную загрузку
export const useBusinessCollection = (
    props: UseBusinessCollectionProps,
): UseBusinessCollectionPayload => {
    const { namespace } = props;
    const dispatch = useDispatch();
    const businesses = useSelector((state) => selectBusinessCollection(state, namespace));
    const isLoading = useSelector((state) => selectBusinessCollectionLoading(state, namespace));
    const filters = useSelector((state) => selectBusinessCollectionFilters(state, namespace));
    const onLoadNext = useCallback(
        (params?: Record<string, any>) => dispatch(loadBusinessCollectionAsync(namespace, params)),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [dispatch],
    );

    return {
        filters,
        businesses,
        isLoading,
        onLoadNext,
    };
};
